import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/_withWorkspace/settings/')({
  beforeLoad: () => {
    // Redirect to general settings as default
    throw redirect({ to: '/settings/general' });
  },
});
